import { type VerdictKey, verdictKeyFromLabel } from '../theme/designTokens';
import type { VerificationResult } from '../types';

export interface VerificationStats {
  total: number;
  accurate: number;
  partiallyAccurate: number;
  inaccurate: number;
  unverifiable: number;
  /** 処理が失敗したもの。判定ではないので正確率の分母から外す。 */
  error: number;
  /** エラーを除いた、実際に判定できた件数。正確率の分母。 */
  judged: number;
  accuracyRate: number;
}

/**
 * 検証結果から統計情報を計算する。
 *
 * 判定文字列を直接見ず、VerdictKey に正規化してから数える。
 * 以前は includes('正確') のような部分一致で振り分けていたため、
 * どのバケツにも入らない値（'検証エラー'）が合計にだけ数えられ、
 * 内訳の合計が total に一致しなかった（#144）。
 */
export const calculateVerificationStats = (results: VerificationResult[]): VerificationStats => {
  const counts: Record<VerdictKey, number> = {
    accurate: 0,
    inaccurate: 0,
    partial: 0,
    unverifiable: 0,
    error: 0,
  };
  for (const r of results) {
    counts[verdictKeyFromLabel(r.result)]++;
  }

  const total = results.length;
  const judged = total - counts.error;
  const accuracyRate = judged > 0 ? ((counts.accurate + counts.partial * 0.5) / judged) * 100 : 0;

  return {
    total,
    accurate: counts.accurate,
    partiallyAccurate: counts.partial,
    inaccurate: counts.inaccurate,
    unverifiable: counts.unverifiable,
    error: counts.error,
    judged,
    accuracyRate,
  };
};
